import React from "react";

export default function MicrosoftAuthCallback() {
  return (
    <div style={{ padding: "24px", textAlign: "center" }}>
      Completing Microsoft sign-in...
    </div>
  );
}
